module.exports = __webpack_public_path__ + "media/images/social-684e69aad17a1361ad8e4183899ed0ce.jpg";